export default __webpack_public_path__ + "static/media/appsSelected.5cbf9b24.svg";